import React, { useCallback } from 'react';
import { ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export type EprgUrlResponseType = {
    eprg_url: string | null;
};

export type GetEprgUrlReturnType = {
    data: EprgUrlResponseType;
};

export const useGetEprgUrl = () => {
    const services = React.useContext(ServicesContext);

    const getEprgUrl = useCallback(async () => {
        try {
            const result: GetEprgUrlReturnType = await services.api.call(
                {
                    method: 'get',
                    url: '/wellmed/api/eprg/url',
                },
                { handledErrors: true }
            );
            return result.data;
        } catch (error) {
            throw defaultApiResponseHandler(error as CustomError);
        }
    }, [services.api]);

    return getEprgUrl;
};
